import * as styles from "./PaletteFooter.css";

import { Kbd } from "@frontend/components/atoms/Kbd";
import { useLingui } from "@lingui/react";

import { commandPaletteLabels } from "../i18n/labels";

export function PaletteFooter() {
  const { _ } = useLingui();

  return (
    <div className={styles.footer}>
      <span className={styles.hint}>{_(commandPaletteLabels.sameKeyIsOr)}</span>
      <span className={styles.hint}>
        {_(commandPaletteLabels.differentKeysAreAnd)}
      </span>
      <span className={styles.hint}>
        <Kbd>space</Kbd> {_(commandPaletteLabels.spaceValidatesFilter)}
      </span>
      <span className={styles.hint}>
        <Kbd>⌫</Kbd> {_(commandPaletteLabels.backspaceRemovesLastFilter)}
      </span>
      <span className={styles.hint}>
        <Kbd>↑↓</Kbd> {_(commandPaletteLabels.navigateHint)} · <Kbd>↵</Kbd>{" "}
        {_(commandPaletteLabels.openHint)} · <Kbd>esc</Kbd>{" "}
        {_(commandPaletteLabels.clearHint)}
      </span>
    </div>
  );
}
